import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'EssentialOilsGuideCard',
  props: {
    title: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var link = computed(function () {
      var frenchPath = {
        name: 'product-slug',
        query: {
          page: 'library'
        },
        params: {
          slug: props.slug.replace('?page=library', '')
        }
      };
      var italianPath = {
        name: 'guide-slug',
        params: {
          slug: props.slug
        }
      };
      var route = locale === 'fr' ? frenchPath : italianPath;
      return app.localePath(route);
    });
    return {
      __sfc: true,
      props: props,
      app: app,
      locale: locale,
      translate: translate,
      link: link,
      AzButton: AzButton,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});